import React from "react";
import { message } from "antd";
import { Drawer } from "antd";
import { Form, Button, Icon } from "antd";

import LayoutDefault from "../../shared/LayoutDefault";

import SessionTable from "./SessionTable";
import SessionForm from "./SessionForm";

class SessionView extends React.Component {
  static defaultProps = {
    onCreate: async (row) => {},
    onUpdate: async (row) => {},
    onDelete: async (row) => {},
  };

  static getDerivedStateFromProps(props, state) {
    // Any time the session list changes, update the edit data
    const {
      data: { sessionSet, loading },
    } = props;
    const { edit } = state;
    if (!loading && sessionSet && edit) {
      const updatedData = sessionSet.reduce(
        (acc, x) => (x.id === edit.id ? x : acc),
        undefined
      );
      if (updatedData) {
        return { edit: updatedData };
      }
    }
    return null;
  }

  state = {
    loading: false,
    edit: undefined,
    create: undefined,
  };

  handleCreateRequested = () => {
    this.setState({ create: new Date() });
  };

  handleCreateCancelled = () => {
    this.setState({ create: undefined });
  };

  handleCreateSubmitted = async (values) => {
    this.setState({ loading: true });
    const errors = await this.props.onCreate(values);
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    this.setState({ create: undefined });
    message.success("The session has been created");
  };

  handleEditRequested = (row) => {
    this.setState({ edit: row });
  };

  handleEditCancelled = () => {
    this.setState({ edit: undefined });
  };

  handleEditSubmitted = async (values) => {
    const {
      edit: { id },
    } = this.state;
    this.setState({ loading: true });
    const errors = await this.props.onUpdate({ ...values, id });
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    message.success("The session has been updated");
  };

  handleDeleteConfirmed = async (row) => {
    this.setState({ loading: true });
    await this.props.onDelete(row);
    message.success("The session has been deleted");
    this.setState({ loading: false });
  };

  render() {
    const {
      data: { sessionSet, scenarioSet, licenseSet, me, loading: dataLoading },
    } = this.props;

    const { create, edit, loading } = this.state;

    return (
      <LayoutDefault>
        {!dataLoading && (
          <React.Fragment>
            <Form.Item>
              <Button
                size="small"
                onClick={this.handleCreateRequested}
                loading={loading}
              >
                <Icon type="plus" />
                Create a session
              </Button>
            </Form.Item>

            <SessionTable
              sessionSet={sessionSet}
              licenseSet={licenseSet}
              scenarioSet={scenarioSet}
              loading={loading}
              onEdit={this.handleEditRequested}
              onDelete={this.handleDeleteConfirmed}
            />

            <Drawer
              visible={!!create}
              title="Create session"
              onClose={this.handleCreateCancelled}
              width="60%"
            >
              <SessionForm
                key={create}
                row={{}}
                licenseSet={licenseSet}
                scenarioSet={scenarioSet}
                user={me.user}
                loading={loading}
                onSubmit={this.handleCreateSubmitted}
              />
            </Drawer>

            <Drawer
              visible={!!edit}
              title={edit && `Edit ${edit.pin}`}
              onClose={this.handleEditCancelled}
              width="60%"
            >
              {edit && (
                <SessionForm
                  key={JSON.stringify(edit)}
                  row={edit}
                  loading={loading}
                  onSubmit={this.handleEditSubmitted}
                />
              )}
            </Drawer>
          </React.Fragment>
        )}
      </LayoutDefault>
    );
  }
}

export default SessionView;
